export function formatDeliveryText(deliveryTime, stock) {
  if (Number(stock) > 0) return 'Sofort lieferbar (2-10 Werktage)';
  const delivery = String(deliveryTime || '').trim();
  if (!delivery) return 'auf Anfrage';
  if (/vergriffen|ausverkauft|nicht\s+(lieferbar|verfügbar)|nachschub|auf\s+anfrage/i.test(delivery)) return delivery;
  const normalized = delivery.replace(/\s*Werk\s*$/, ' Werktage').replace(/\s*WT\b/, ' Werktage');
  return /^ca\./i.test(normalized) ? normalized : `ca. ${normalized}`;
}
